import React, { useEffect, useState } from "react";
import { ReactComponent as EditIcon } from "../../Global Icons/Edit.svg";
import { ReactComponent as DeleteIcon } from "../../Global Icons/Delete.svg";
import { ReactComponent as CloseIcon } from "../../Global Icons/CancelButton.svg";
import TextInput from "../../Global Functions/textInput";
import SelectInput from "../../Global Functions/selectInput";
import { useDispatch, useSelector } from "react-redux";
import { addVR, removeVr } from "../../Redux/Actions/projectActions";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import "./addVr.css";

const AddVr = ({ vrData, onVrRemoved, onClose }) => {
  const [formData, setFormData] = useState({
    configuration: "",
    configuration_id: "",
    iframe_url: "",
    is_user_vr: true,
  });
  const [urlIframe, setUrlIframe] = useState({
    project_id: vrData?.data?._id || "",
    three_sixty: [],
  });
  const [editingIndex, setEditingIndex] = useState(null);
  const [otherPopup, setOtherPopup] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { units } = useSelector((state) => state.units || {});

  useEffect(() => {
    if (vrData?.data?.three_sixty && vrData?.data?.three_sixty?.length > 0) {
      setUrlIframe((prevData) => ({
        ...prevData,
        three_sixty: vrData?.data?.three_sixty,
      }));
    }
  }, [vrData]);

  const handleAddEntry = (event) => {
    event.preventDefault();
    const { configuration, configuration_id, iframe_url, is_user_vr } = formData;
    
    if (!configuration || !configuration_id || !iframe_url) {
      return toast.error("All fields are required!");
    }

    if (editingIndex !== null) {
      // Update existing entry
      setUrlIframe((prev) => ({
        ...prev,
        three_sixty: prev.three_sixty.map((item, index) =>
          index === editingIndex
            ? {
                ...item,
                configuration,
                configuration_id,
                iframe_url,
                is_user_vr,
              }
            : item
        ),
      }));
      toast.success("VR Tour updated successfully!");
      setEditingIndex(null);
    } else {
      // Add new entry
      setUrlIframe((prev) => ({
        ...prev,
        three_sixty: [
          ...prev.three_sixty,
          {
            configuration,
            configuration_id,
            iframe_url,
            is_user_vr,
            key_saved: false,
          },
        ],
      }));
      toast.success("VR Tour added successfully!");
    }

    // Reset form
    setFormData({
      configuration: "",
      configuration_id: "",
      iframe_url: "",
      is_user_vr: true,
    });
  };

  const handleEdit = (index) => {
    const vrToEdit = urlIframe.three_sixty[index];
    setFormData({
      configuration: vrToEdit.configuration,
      configuration_id: vrToEdit.configuration_id,
      iframe_url: vrToEdit.iframe_url,
      is_user_vr: vrToEdit.is_user_vr,
    });
    setEditingIndex(index);
    
    // Scroll to form
    setTimeout(() => {
      document.querySelector('.vr-form-section')?.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'nearest' 
      });
    }, 100);
  };

  const handleCancelEdit = () => {
    setEditingIndex(null);
    setFormData({
      configuration: "",
      configuration_id: "",
      iframe_url: "",
      is_user_vr: true,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (urlIframe.three_sixty.length === 0) {
        return toast.error("Please Add the link using ADD Button!!");
      }
      const response = await dispatch(addVR(urlIframe));
      if (response.statusCode === 200) {
        if (typeof onVrRemoved === "function") {
          onVrRemoved();
        }
        navigate("/manage_projects");
      }
    } catch (error) {
      console.log(error?.data?.response?.message);
      toast.error("Failed to submit VR Tours");
    }
  };

  const handleRemove = async (indexToRemove) => {
    const vrToRemove = urlIframe.three_sixty[indexToRemove];
    
    if (!vrToRemove || !vrToRemove._id) {
      setUrlIframe((prevData) => ({
        ...prevData,
        three_sixty: prevData.three_sixty.filter(
          (_, index) => index !== indexToRemove
        ),
      }));
      toast.success("VR Tour removed!");
      return;
    }
    
    try {
      const removePayload = {
        project_id: urlIframe.project_id,
        three_sixty_id: vrToRemove._id,
      };
      const response = await dispatch(removeVr(removePayload));
      if (response.statusCode === 200) {
        setUrlIframe((prevData) => ({
          ...prevData,
          three_sixty: prevData.three_sixty.filter(
            (_, index) => index !== indexToRemove
          ),
        }));
        toast.success("VR Tour deleted successfully!");
        if (typeof onVrRemoved === "function") {
          onVrRemoved();
        }
      } else {
        toast.error("Failed to remove VR");
      }
    } catch (error) {
      toast.error("Error removing VR");
      console.error(error);
    }
  };

  const handleClearAll = () => {
    setUrlIframe((prevData) => ({
      ...prevData,
      three_sixty: [],
    }));
    setEditingIndex(null);
    setFormData({
      configuration: "",
      configuration_id: "",
      iframe_url: "",
      is_user_vr: true,
    });
    if (typeof onClose === "function") {
      onClose();
    }
  };

  return (
    <div className="vr-modal-container">
      {/* Header */}
      <div className="vr-modal-header">
        <h2 className="vr-modal-title">Add 360° / VR Experience</h2>
        <CloseIcon
          className="vr-close-icon"
          onClick={handleClearAll}
          title="Close"
        />
      </div>

      <div className="vr-modal-content">
        {urlIframe.three_sixty && urlIframe.three_sixty.length > 0 && (
          <div className="vr-list-section">
            <h3 className="vr-list-heading">Added VR Tours</h3>
            <div className="vr-list-container">
              {urlIframe.three_sixty.map((data, index) => (
                <div
                  key={data.configuration_id || index}
                  className={`vr-list-item ${editingIndex === index ? 'vr-editing' : ''}`}
                >
                  <div className="vr-item-content">
                    <h4 className="vr-item-title">{data.configuration}</h4>
                    <p className="vr-item-url">{data.iframe_url}</p>
                    <div className="vr-visibility-status">
                      {data.is_user_vr ? (
                        <span className="status-public">Visible to All</span>
                      ) : (
                        <span className="status-private">Agent only</span>
                      )}
                    </div>
                  </div>
                  <div className="vr-item-actions">
                    <button 
                      className="vr-action-btn vr-edit-btn" 
                      onClick={() => handleEdit(index)}
                      title="Edit"
                    >
                      <EditIcon />
                    </button>
                    <button
                      className="vr-action-btn vr-delete-btn"
                      onClick={() => handleRemove(index)}
                      title="Delete"
                    >
                      <DeleteIcon />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Add New VR Form */}
        <div className="vr-form-section">
          <h3 className="vr-form-heading">
            {editingIndex !== null 
              ? "Edit VR Tour" 
              : urlIframe.three_sixty.length > 0 
                ? "Add Another" 
                : "Add New VR Tour"}
          </h3>

          <div className="vr-form-grid">
            <SelectInput
              label="Configuration"
              disabled={otherPopup ? true : false}
              required={true}
              value={formData.configuration_id}
              placeholder="Select an Option"
              options={[
                ...(Array.isArray(vrData?.data?.units)
                  ? vrData.data.units.map((unit) => ({
                      value: unit?._id,
                      label: unit?.name,
                    }))
                  : []),
                { value: "others", label: "Other's" },
              ]}
              onChange={(e) => {
                if (e.target.value === "others") {
                  setFormData((prev) => ({
                    ...prev,
                    configuration_id: "others",
                    configuration: "",
                  }));
                } else {
                  const selected = vrData.data.units.find(
                    (unit) => unit._id === e.target.value
                  );
                  setFormData((prev) => ({
                    ...prev,
                    configuration_id: selected._id,
                    configuration: selected.name,
                  }));
                }
              }}
            />

            {formData.configuration_id === "others" && (
              <TextInput
                label="Title"
                required={true}
                value={formData.configuration}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    configuration: e.target.value,
                  }))
                }
              />
            )}

            {otherPopup && (
              <SelectInput
                label="All Configurations"
                value={formData.configuration_id}
                required={true}
                placeholder="Select an Option"
                options={
                  Array.isArray(units?.data)
                    ? units.data.map((unit) => ({
                        value: unit._id,
                        label: unit.name,
                      }))
                    : []
                }
                onChange={(e) => {
                  const selected = units.data.find(
                    (unit) => unit._id === e.target.value
                  );
                  setFormData((prev) => ({
                    ...prev,
                    configuration_id: selected._id,
                    configuration: selected.name,
                  }));
                }}
              />
            )}

            <div className="vr-url-input-wrapper">
              <TextInput
                label="Iframe / URL"
                required={true}
                value={formData.iframe_url}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    iframe_url: e.target.value,
                  }))
                }
              />
              {formData.iframe_url.trim().length > 0 && (
                <button 
                  className="vr-add-btn" 
                  onClick={handleAddEntry}
                >
                  {editingIndex !== null ? "Update" : "Add"}
                </button>
              )}
            </div>

            <div className="vr-checkbox-wrapper">
              <label className="vr-checkbox-label">
                <input
                  type="checkbox"
                  className="vr-checkbox-input"
                  checked={formData.is_user_vr}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      is_user_vr: e.target.checked,
                    }))
                  }
                />
                <span className="vr-checkbox-text">
                  User Available
                  {!formData.is_user_vr && (
                    <span className="disclaimer-text">(VR hidden from users)</span>
                  )}
                </span>
              </label>
            </div>

            {editingIndex !== null && (
              <button 
                className="vr-cancel-edit-btn" 
                onClick={handleCancelEdit}
              >
                Cancel Edit
              </button>
            )}
          </div>
        </div>

        {/* Submit Buttons */}
        {urlIframe.three_sixty.length > 0 && (
          <div className="vr-submit-section">
            <button className="vr-submit-btn" onClick={handleSubmit}>
              Submit All
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AddVr;